module.exports = __webpack_public_path__ + "28e4d47d7d125922411a8ff4809eb0e7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-ballet-s.png
// module id = 2421
// module chunks = 0